<template>
  <div>
    <ul class="modele-con">
        <li v-for="(item,index) in list" :key="index" @click="handleDetail(item.name)">
            <!-- <img class="img-right" :src="cdnUrl + 'Firnx88-us9t8CZl1ck92FFR98eZ'" alt=""> -->
            <div style="flex: 1;">
                <p class="model-tip">{{ item.title }}</p>
                <p class="model-content">{{ item.content }}</p>
            </div>
            <img class="img-icon" :src="cdnUrl + item.img" alt="">
        </li>
    </ul>
    <footerLine></footerLine>
  </div>
</template>

<script>
import { centrifugeRecord } from '@/libs/common'
import footerLine from '@/components/footerLine'
export default {
    components:{ footerLine },
    data() {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            list: [
                {img: 'FtVSDzmy6GaDV4BzFQ6qxYIPX1s9',title: '移液器操作视频', content: '操作攻略 一应俱全', name: 'pipOperVideo'},
                {img: 'FrRQo7unz2iAxr_s_bGeA-vcK8tO',title: '移液器维护保养', content: '让您的移液器始终保持最佳状态', name: 'pipMaintain'},
                {img: 'Fs9vTqGB7XYnbahWECK-HjkPKA86',title: '科普小课堂', content: '不能不知道的移液知识', name: 'pipClassRoom'},
                {img: 'Fng20kFSG3uTokAINsFWdR5h5a4b',title: '用户故事', content: '用户分享的移液技巧和应用',name: 'pipUserStory'},
            ],
        }
    },
    methods: {
        handleDetail(name) {
            this.$router.push({
                name: name
            })
            let para = {
                type: name == 'pipOperVideo'? 21 : (name == 'pipMaintain' ? 22 : (name == 'pipClassRoom' ? 23 : 24)), // 21 移液器操作视频 22 移液器维护保养 23 科普小课堂 24 用户故事
                uid: this.$store.state.user.id || 0,
                action: 1,
                type_id: 0
            }
            centrifugeRecord(para)
        }
    }
}
</script>

<style lang="scss" scoped>
.modele-con {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    li {
        display: flex;
        // justify-content: space-between;
        align-items: center;
        position: relative;
        width: rem(343);
        height: rem(105);
        margin-top: rem(20);
        background: #F8FEFF;
        border-radius: rem(6);
        box-shadow: 0px 2px 6px 0px rgba(102,102,102,0.5);
        box-sizing: border-box;
    }
    // li:nth-child(1) {
    //     padding-right: rem(64);
    // }
    .model-tip {
        
        margin-left: rem(19);
        font-size: rem(21);
        font-weight: bold;
        color: #333333c7;
    }
    .model-content {
        margin-left: rem(19);
        line-height: rem(21);
        font-size: rem(12);
        color: #666666;
    }
    .img-icon {
        width: rem(58);
        height: rem(58);
        margin-left: rem(30);
        margin-right: rem(36);
    }
    .img-right {
        position: absolute;
        top: 0;
        right: 0;
    }
}
</style>